import { ProductsActionsSearchHeader } from 'components/pages/projects/helpers/ProductActions/productsActions';
import { ContactRequestContext } from 'types/ContactRequests';
import { useContext } from 'react';
import { SearchContext } from 'context/SearchContext';
import { SearchDocument } from 'types/Search';
import { IS_UXBEAUTY } from 'components/constants/Constants';
import { Box } from '@mui/material';
import { envs } from '../../../../../envs';

interface SearchContactButtonBarProps {
  product: SearchDocument;
  showAddToProject?: boolean;
  logEventsData?: any;
}

const SearchContactButtonBar = ({
  product,
  logEventsData,
  showAddToProject = true
}: SearchContactButtonBarProps) => {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  const productType = product.type!;
  const { isPortal } = useContext(SearchContext);

  return (
    <Box sx={{ display: 'flex', marginTop: 2, flexWrap: 'wrap' }}>
      {product?.old_key && (
        <ProductsActionsSearchHeader
          logEventsData={{
            products: [product],
            searchRequest: logEventsData
          }}
          products={[isPortal ? product.event.key : product.old_key]}
          productName={product?.name ?? ''}
          productsType={productType}
          context={
            IS_UXBEAUTY
              ? {
                  type: ContactRequestContext.SUPPLIER_PORTAL,
                  portalKey: envs.REACT_APP_COVALO_WHITELABEL_EVENT_KEY
                }
              : product?.event?.event?.key
              ? {
                  type: ContactRequestContext.BRAND_PORTAL,
                  portalKey: product.event.event.key
                }
              : {
                  type: ContactRequestContext.COVALO
                }
          }
          showAddToProject={showAddToProject}
          documents={product?.assets}
          companyKey={product?.company?.key}
        />
      )}
    </Box>
  );
};

export default SearchContactButtonBar;
